export const normalizeComparableString = (s: string): string =>
  s.normalize('NFD').replace(/\p{M}+/gu, '').toLowerCase().trim()

export const trimUnknownToString = (value: unknown): string =>
  value === undefined || value === null ? '' : String(value).trim()

export const camelCaseToScreamingSnakeCase = (camelCaseId: string): string =>
  camelCaseId.replace(/([A-Z])/g, '_$1').replace(/^_/, '').toUpperCase()
